export enum TemplateDatafieldKey {
	CollateralDescription = 'collateralDescription'
}
